import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSyncmodule = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12 3.99954L12 2.20954C12 1.75954 12.54 1.53954 12.85 1.85954L15.65 4.64954C15.85 4.84954 15.85 5.15954 15.65 5.35954L12.86 8.14954C12.54 8.45954 12 8.23954 12 7.78954L12 5.99954C8.69 5.99954 6 8.68954 6 11.9995C6 12.7895 6.15 13.5595 6.44 14.2495C6.59 14.6095 6.48 15.0195 6.21 15.2895C5.7 15.7995 4.84 15.6195 4.57 14.9495C4.2 14.0395 4 13.0395 4 11.9995C4 7.57954 7.58 3.99954 12 3.99954ZM12 17.9995C15.31 17.9995 18 15.3095 18 11.9995C18 11.2095 17.85 10.4395 17.56 9.74954C17.41 9.38954 17.52 8.97954 17.79 8.70954C18.3 8.19954 19.16 8.37954 19.43 9.04954C19.8 9.95954 20 10.9595 20 11.9995C20 16.4195 16.42 19.9995 12 19.9995L12 21.7895C12 22.2395 11.46 22.4595 11.15 22.1395L8.36 19.3495C8.16 19.1495 8.16 18.8395 8.36 18.6395L11.15 15.8495C11.46 15.5395 12 15.7595 12 16.2095L12 17.9995Z",
		fill: "black"
	})]
});
const ForwardRef = forwardRef(SvgSyncmodule);
export default ForwardRef;
